export default __webpack_public_path__ + "static/media/08_photo.c32106ec.jpeg";